import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";
import utils from "@/utils";
import { isArray } from "lodash";

export const createEditPageMixin = {
  mixins: [checkPermissionsMixin],

  props: {
    actionType: {
      type: String,
    },

    submitButtonDisabled: {
      type: Boolean
    },

    submissionError: {
      type: Error
    }
  },

  computed: {
    allFieldsAreValid() {
      if(this.validation){
        for (let invalidItem of Object.values(this.validation)) {
          if (invalidItem) return false;
        }
      }
      return true;
    }
  },

  watch: {
    allFieldsAreValid(newValue) {
      this.$emit("update-fields-validity", newValue);
    }
  },

  methods: {
    pageTitle(actionType, mainWord) {
      if (actionType === "create") {
        return this.$t("New" + mainWord);
      } else {
        return this.$t("Update" + mainWord);
      }
    },

    submitButtonLabel(actionType) {
      if (actionType === "create") {
        return this.$t("Create");
      } else {
        return this.$t("Save");
      }
    },

    updateField(fieldName, value) {
      this.$emit("update-field", { fieldName: fieldName, value: value });
    },

    updateSelectField(fieldName, validationName, value) {
      this.updateField(fieldName, value);
      this.validateSelect(validationName, value);
    },

    validateString(invalidItem, string) {
      this.validation[invalidItem] = !utils.validateString(string);
    },

    validateUserName(invalidItem, string) {
      this.validation[invalidItem] = !utils.validateUserName(string);
    },

    validateSelect(invalidItem, selectValue) {
      this.validation[invalidItem] = !utils.validateEmptySelect(selectValue);
    },

    validateEmail(email) {
      this.validation.badEmail = !utils.validateEmail(email);
    },

    prepareListOfIDsToSend(listOfIDs) {
      let preparedList = [];
      for (let itemID of listOfIDs) {
        preparedList.push({ id: itemID });
      }
      return preparedList;
    },

    prepareListOfObjectsToSend(listOfObjects, idAttribute = "id") {
      let preparedList = [];
      for (let item of listOfObjects) {
        preparedList.push({ id: item[idAttribute] });
      }
      return preparedList;
    },

    submit() {
      this.$emit("save");
    },

    closePage() {
      this.$emit("close");
    },

    /**
     * Get mandatory fields that are missing to be filled
     *
     * @param object
     * @param mandatoryFields
     */
    getMissingFieldsList(object, mandatoryFields) {
      let missingFieldsList = [];
      mandatoryFields.forEach(item => {
        if (
          object[item] === null ||
          object[item] === "" ||
          (isArray(object[item]) && object[item].length === 0)
        ) {
          if (item.includes("_")) {
            item = item.replace("_", " ");
          }
          missingFieldsList.push(item);
        }
      });

      return missingFieldsList;
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/management/createEditPageMixin.js